import { env } from "../env";
import { initializeApp, type FirebaseOptions } from "firebase/app";
import { connectAuthEmulator, getAuth, type Auth } from "firebase/auth";

export function getFirebaseOptions(): FirebaseOptions {
  const useEmulator = env.MODE === "development";
  return {
    apiKey: env.VITE_FIREBASE_API_KEY,
    authDomain: useEmulator ? window.location.host : env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: env.VITE_FIREBASE_APP_ID,
  };
}

export function createFirebaseAuth(): Auth {
  const auth = getAuth(initializeApp(getFirebaseOptions()));
  if (env.MODE === "development") {
    console.info("Using Firebase Auth Emulator");
    connectAuthEmulator(auth, window.location.origin);
  }
  return auth;
}
